import { useEffect, useState } from "react";
import { keyframes } from "@emotion/react";
import { Box, ButtonBase, Tooltip } from "@mui/material";
import { withStyles } from "@mui/styles";
import { Modals } from "./Modals";
import { BibleIcon } from '../../core/global/Icons';
import moment from "moment/moment";

const shine = keyframes`
    0% { left: -75%; }
    100% { left: 125%; }
`;

const ToolTip = withStyles({
    tooltip: {
        color: "#ffffff",
        backgroundColor: "#030D1F",
        padding:'10px',
        boxShadow:'0 1rem 3rem rgba(0, 0, 0, .175) !important',
    },
    arrow: {
        color: "#030D1F",
        boxShadow:'0 1rem 3rem rgba(0, 0, 0, .175) !important',
    },
})(Tooltip);    

export const NavigationBible = ({ size = 24 }) => {
    const __SESSION_BIBLE = JSON.parse(localStorage.getItem('bible_toggle_session'))

    const [open, setOpen] = useState(false)

    const [bibleVerse, setBibleVerse] = useState({
            bookname:'',
            chapter:0,
            verse_no:0,
            verses:'',
            stat:''
        })
    
        const __init = async() => {
            try {
                const url = "https://api.allorigins.win/raw?url=" + encodeURIComponent("https://biblebytopic.com/api/getrandompopularverse-nkjv");
                const response = await fetch(url);
                if (!response.ok) throw new Error(`Response status: ${response.status}`);

                const res = await response.json();
                if (res) {
                    if (__SESSION_BIBLE === null || (__SESSION_BIBLE?.date !== moment().format('YYYY-MM-DD'))) {
                        localStorage.setItem('bible_toggle_session', JSON.stringify({tool_id:process.env.REACT_APP_TID_BIZ, date:moment().format('YYYY-MM-DD'), toggle:true }))
                        setOpen(true)
                    }else{
                        setOpen(__SESSION_BIBLE?.toggle)
                    }
                    const text = res?.text[0]
                    setBibleVerse({...bibleVerse, 
                        bookname:text.bookname,
                        chapter:text.chapter,
                        verse_no:text.startingverse,
                        verses:text.text,
                        stat:''
                    })
                }
            } catch (error) {
                // if (__SESSION_BIBLE === null || (__SESSION_BIBLE?.date !== moment().format('YYYY-MM-DD'))) {
                //     setOpen(true)
                // }
                // // My Bible verse whole my life:
                // setBibleVerse({...bibleVerse, 
                //     bookname:'Hebrews',
                //     chapter:'6',
                //     verse_no:'10',
                //     verses:'For God is not unrighteous to forget your work and labour of love, which ye have shewed toward his name, in that ye have ministered to the saints, and do minister.',  
                //     stat:'default' 
                // })
                // // setOpen(true)
                console.error(error.message);
            }
        }
    
        useEffect(() => {
            __init()
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])
  
    return (
        <>
            <Modals open={open} setOpen={setOpen} bibleVerse={bibleVerse} __SESSION_BIBLE={__SESSION_BIBLE} />
            <ToolTip bgcolor='primary.main' title={'Daily Guide Words'} 
                sx={{
                    margin: '0 14px 0 14px',
                    color: "#ffffff",
                    backgroundColor: "#030D1F",
                    padding:'10px',
                    boxShadow:'0 1rem 3rem rgba(0, 0, 0, .175) !important',
                }}
            >
                <ButtonBase
                    aria-label="Daily Guide Words"
                    onClick={()=>setOpen(true)}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "2px",
                        p: 0,
                        flexShrink: 0,
                        borderRadius: "6px",
                    }}
                    >
                    <Box
                        sx={{
                        position: "relative",
                        width: size,
                        height: size,
                        color: '#292D32',
                        borderRadius: 2,
                        overflow: "hidden",
                        "& svg": {
                            display: "block",
                        },
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: "-75%",
                            width: "50%",
                            height: "100%",
                            background:
                            "linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%)",
                            transform: "skewX(-20deg)",
                            animation: `${shine} 2.5s infinite`,
                        },
                        }}
                    >
                        <BibleIcon size={size} />
                    </Box>
                </ButtonBase>
            </ToolTip>
        </>
    )
}
